import { AppointmentStatus } from "../../../../api/src/appointment/entities/appointment-status.enum";
import { Appointment } from "../../../../api/src/appointment/entities/appointment.entity";
import { BaseService } from "./common/base";

export class PatientService extends BaseService<any> {
  constructor() {
    super("patient");
  }

  getById = ({ patientId }) => this._get(`/${patientId}`);

  searchByNir = ({ nir }) => this._get(`/nir/${nir}`);

  getAppointments = (
    id,
    params: {
      start?: string | Date;
      end?: string | Date;
      status?: AppointmentStatus;
      $limit?: number;
      $offset?: number;
      $desc?: string;
      $asc?: string;
    },
    opts = {}
  ): Promise<{ appointments: Appointment[]; meta: { total: number } }> =>
    this._get(`/${id}/appointments`, {
      params,
      ...opts,
    });
}
